import React from 'react';

const SvgComments = (props) => (
  <svg width={'1em'} height={'1em'} viewBox="0 0 13 12" {...props}>
    <g
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
    >
      <path
        fillRule="nonzero"
        d="M10.69 6.066c-.104-.106-.275-.106-.366 0L6.984 9.42a.26.26 0 0 0-.078.184v1.118c0 .145.117.264.262.264H8.28a.256.256 0 0 0 .183-.08l3.34-3.355a.255.255 0 0 0 0-.368L10.69 6.066zm-2.212 4.092l-.747-.737 2.134-2.145.747.75-2.134 2.132zm-1.035-.29l.59.592h-.59v-.592zm3.523-2.223l-.747-.75.276-.277.746.75-.275.277z"
      />
      <path d="M2.153 7.987L1.523 10a.275.275 0 0 0 .066.264.314.314 0 0 0 .197.078c.026 0 .052 0 .079-.013l2.828-.947c.014 0 .026.013.04.013a5.94 5.94 0 0 0 1.374.158.263.263 0 0 0 0-.527c-.432 0-.851-.052-1.257-.145-.04-.013-.105-.026-.105-.026a.263.263 0 0 0-.144 0l-2.423.803.524-1.67a.275.275 0 0 0-.066-.264s-.091-.08-.13-.132c-.641-.657-.982-1.46-.982-2.316 0-2.065 2.056-3.75 4.583-3.75 2.528 0 4.584 1.685 4.584 3.75 0 .145.117.264.261.264a.263.263 0 0 0 .262-.264C11.214 2.921 8.923 1 6.107 1 3.292 1 1 2.921 1 5.276c0 .974.406 1.934 1.14 2.684 0 .014.013.014.013.027z" />
    </g>
  </svg>
);

export default SvgComments;
